/**
 * Design Library — schema (data-driven field spec).
 *
 * The Design Library is reusable DESIGN KNOWLEDGE: semantic patterns a senior
 * designer reaches for, never components, UI, assets, or templates. A pattern
 * describes what a piece of a design is FOR and how it should be reasoned
 * about — never how it is drawn.
 *
 * The contract is expressed as DATA: the validator iterates these field lists,
 * so adding a field or a family is a one-line change and the catalog scales to
 * 1000+ patterns without touching the architecture.
 */

export const LIBRARY_SCHEMA_ID = 'library/1';
export const LIBRARY_VERSION = 1;
export const DEFAULT_PATTERN_VERSION = 1;

/** Pattern families — the shelf a pattern lives on. */
export const FAMILIES = Object.freeze(['layout', 'hero', 'section', 'block', 'cover', 'industry']);

/**
 * What a pattern can carry or needs. Controlled so selection can query by
 * capability (e.g. "an offer-led brief needs patterns with the `offer`
 * capability"). Additive.
 */
export const CAPABILITIES = Object.freeze([
  'offer', 'cta', 'image', 'gallery', 'pricing', 'stats', 'testimonial', 'contact',
  'timeline', 'qr', 'logo', 'table', 'icon-list', 'menu', 'schedule', 'form', 'map',
  'fullbleed', 'text-led', 'image-led', 'multi-column', 'list',
]);

/** Identity fields every pattern must carry. */
export const IDENTITY_FIELDS = Object.freeze(['id', 'name']);

/** Prose fields — the reasoning a pattern encodes. */
export const PROSE_FIELDS = Object.freeze([
  'purpose', 'communicationGoal', 'visualGoal', 'contentGoal', 'marketingGoal',
  'compositionPhilosophy', 'hierarchyPhilosophy',
]);

/** Open-vocabulary lists (kept freeform so the catalog scales). */
export const FREEFORM_LIST_FIELDS = Object.freeze([
  'idealDocuments', 'idealIndustries', 'idealAudiences', 'typicalSections',
  'preferredComponents', 'premiumCues', 'thingsToAvoid', 'variationRules', 'tags',
]);

/** Cross-referenced lists — integrity is enforced. */
export const GENOME_REF_FIELD = 'idealGenomes';
export const CAPABILITY_FIELD = 'capabilities';
export const PATTERN_REF_FIELDS = Object.freeze(['compatiblePatterns', 'incompatiblePatterns', 'dependencies']);

/** Every key a pattern may declare. */
export const ALLOWED_PATTERN_KEYS = Object.freeze([
  ...IDENTITY_FIELDS, 'family', 'variantOf', 'version',
  ...PROSE_FIELDS, ...FREEFORM_LIST_FIELDS,
  GENOME_REF_FIELD, CAPABILITY_FIELD, ...PATTERN_REF_FIELDS,
  'expansionRules',
]);
